<template>
    <div id="main">
        <div class="page page-container">
            <div class="novo-motivonaovenda">
                <!-- TÍTULO -->
                <h1 class="title">
                    {{ $t("motivo-nao-venda") }}:
                    {{
                        !motivonaovenda.idmotivonaovenda
                            ? $t("novo-motivo-nao-venda")
                            : motivonaovenda.descricao
                    }}
                </h1>
                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li>
                            <a class="a-inativo">{{ $t("vendas") }}</a>
                        </li>
                        <li>
                            <a class="a-inativo">{{ $t("cadastros") }}</a>
                        </li>
                        <li>
                            <a
                                @click="
                                    $router.push({
                                        name: 'venda-motivo-nao-venda',
                                    })
                                "
                                >{{ $t("motivos-nao-venda") }}</a
                            >
                        </li>
                        <li>
                            <a aria-current="page">{{
                                !motivonaovenda.idmotivonaovenda
                                    ? $t("novo-motivo-nao-venda")
                                    : motivonaovenda.descricao
                            }}</a>
                        </li>
                    </ul>
                </nav>

                <!-- FORMULÁRIO -->
                <div class="columns mt-3">
                    <div class="column is-full">
                        <div class="columns is-full">
                            <div class="column is-2">
                                <v-input
                                    :id="generateId(1)"
                                    ref="idErpInput"
                                    v-model="motivonaovenda.idmotivonaovendaerp"
                                    placeholder="placeholder-preencha"
                                    :maxlength="30"
                                    title="codigo"
                                    uppercase
                                    required
                                    :invalid="!motivonaovenda.idmotivonaovendaerp"
                                    tooltipLabel="cod-ref"
                                    :disabled="motivonaovendaIntegracao"
                                />
                            </div>
                            <div class="descricao-input column is-6">
                                <v-input
                                    v-model="motivonaovenda.descricao"
                                    ref="descricaoInput"
                                    :id="generateId(2)"
                                    placeholder="descricao-do-motivo-nao-venda-placeholder"
                                    title="descricao"
                                    :maxlength="100"
                                    :invalid="!motivonaovenda.descricao"
                                    uppercase
                                    :disabled="motivonaovendaIntegracao"
                                    required
                                    tooltipLabel="info-descricao-generica"
                                />
                            </div>
                            <div class="situacao-input column is-2">
                                <vss-select
                                    :id="generateId(3)"
                                    ref="situacaoSelect"
                                    :searchable="false"
                                    :options="situacoes"
                                    v-model="motivonaovenda.situacao"
                                    :getOptionLabel="getLabel"
                                    class="no-clear"
                                    :disabled="motivonaovendaIntegracao"
                                    :mlLabels="true"
                                    title="situacao"
                                    tooltipLabel="info-situacao-generica"
                                />
                            </div>
                            <div class="column is-2">
                                <v-input
                                    :id="generateId(4)"
                                    v-model="motivonaovenda.minimofotos"
                                    ref="minFotosInput"
                                    title="minimo-fotos"
                                    type="tel"
                                    step="1"
                                    :maxlength="3"
                                    :min="0"
                                    :disabled="
                                        motivonaovendaIntegracao || motivonaovenda.ocultafotos
                                    "
                                    required
                                    :invalid="!motivonaovenda.minimofotos"
                                    tooltipLabel="info-qtde-fotos"
                                    tooltipPosition="is-left"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns mt-3">
                    <div class="column is-one-fifth">
                        <b-checkbox
                            :id="generateId(5)"
                            type="is-primary"
                            v-model="motivonaovenda.obrigacontato"
                            :disabled="motivonaovendaIntegracao || motivonaovenda.ocultacontato"
                        >
                            {{ $t("obriga-contato") }}
                        </b-checkbox>
                    </div>
                    <div class="column is-one-fifth">
                        <b-checkbox
                            :id="generateId(6)"
                            type="is-primary"
                            v-model="motivonaovenda.obrigaobservacao"
                            :disabled="
                                motivonaovendaIntegracao || motivonaovenda.ocultaobservacao
                            "
                        >
                            {{ $t("obriga-observacao") }}
                        </b-checkbox>
                    </div>
                    <div class="column is-one-fifth">
                        <b-checkbox
                            :id="generateId(7)"
                            type="is-primary"
                            v-model="motivonaovenda.ocultacontato"
                            :disabled="motivonaovendaIntegracao"
                            @input="
                                validateOculta(
                                    motivonaovenda.ocultacontato,
                                    'contato'
                                )
                            "
                        >
                            {{ $t("oculta-contato") }}
                        </b-checkbox>
                    </div>
                    <div class="column is-one-fifth">
                        <b-checkbox
                            :id="generateId(8)"
                            type="is-primary"
                            v-model="motivonaovenda.ocultaobservacao"
                            :disabled="motivonaovendaIntegracao"
                            @input="
                                validateOculta(
                                    motivonaovenda.ocultaobservacao,
                                    'observacao'
                                )
                            "
                        >
                            {{ $t("oculta-observacao") }}
                        </b-checkbox>
                    </div>
                    <div class="column is-one-fifth">
                        <b-checkbox
                            :id="generateId(9)"
                            type="is-primary"
                            v-model="motivonaovenda.ocultafotos"
                            :disabled="motivonaovendaIntegracao"
                            @input="
                                validateOculta(
                                    motivonaovenda.ocultafotos,
                                    'fotos'
                                )
                            "
                        >
                            {{ $t("oculta-fotos") }}
                        </b-checkbox>
                    </div>
                </div>

                <!-- BOTÕES -->
                <div class="form-buttons">
                    <button
                        class="delete-btn"
                        type="button"
                        @click="
                            $router.push({ name: 'venda-motivo-nao-venda' })
                        "
                    >
                        {{ $t("voltar") }}
                    </button>
                    <button
                        v-if="
                            (allowedCreateMotivo || allowedUpdateMotivo) &&
                            !motivonaovendaIntegracao
                        "
                        class="save-btn"
                        type="button"
                        @click="saveMotivoNaoVenda()"
                        :disabled="isSaving || motivonaovendaIntegracao"
                    >
                        {{ $t("salvar") }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MotivoNaoVendaService from "@/services/MotivoNaoVendaService";
import MotivoNaoVendaValidation from "@/services/validations/MotivoNaoVendaValidation";

export default {
    data() {
        return {
            motivonaovendaIntegracao: this.$store.state.user.tabelasERPWebServer.includes("MOTIVONAOVENDA"),
            service: new MotivoNaoVendaService(this.$http, this.$router),
            validation: new MotivoNaoVendaValidation(this.$root.msgs),
            isSaving: false,
            motivonaovenda: {
                idmotivonaovendaerp: null,
                descricao: "",
                minimofotos: 0,
                obrigacontato: false,
                obrigaobservacao: false,
                ocultacontato: false,
                ocultaobservacao: false,
                ocultafotos: false,
                situacao: { label: "ativo", id: 1 },
            },
            msgs: [],
            isLoading: false,
            situacoes: [
                { label: "inativo", id: 0 },
                { label: "ativo", id: 1 },
            ],
            title: "",
            disabled: false,
            permissao: {},
            isUpdate: false,
        };
    },
    computed: {
        allowedCreateMotivo() {
            return !this.isUpdate && this.permissao.create;
        },
        allowedUpdateMotivo() {
            return this.isUpdate && this.permissao.update;
        },
    },
    created() {
        this.isUpdate =
            this.$route.params.id != null && this.$route.params.id != "new";

    this.permissao = this.hasPermissionAccess('vendas', 'vendas', 'venda-motivo-nao-venda');

        !this.permissao.read &&
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "motivo-nao-venda" },
            });

        !this.isUpdate &&
            !this.allowedCreateMotivo &&
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "motivo-nao-venda" },
            });

        if (this.$route.params.id) {
            this.carregarDados(this.$route.params.id);
        } else {
            this.motivonaovenda.situacao = this.situacoes[1];
        }
    },
    mounted() {
        this.$refs.descricaoInput.$refs.typed.focus();
    },
    methods: {
        carregarDados(id) {
            this.$store.commit("addLoader");

            this.service
                .find(id)
                .then((body) => {
                    if (body.content) {
                        this.motivonaovenda = body.content;
                        this.title = this.motivonaovenda.descricao;
                        if (body.content.situacao in [0, 1]) {
                            this.motivonaovenda.situacao =
                                this.situacoes[body.content.situacao];
                        } else {
                            console.warn(
                                `ID de situação inválido ao carregar motivo de não venda: ${body.content.situacao}`
                            );
                            this.motivonaovenda.situacao = this.situacoes[1];
                        }
                    } else {
                        this.$router.push({
                            name: "new-venda-motivo-nao-venda",
                        });
                    }
                })
                .catch((e) => {
                    console.error("Erro ao carregar motivo de não venda.", e);
                    this.$root.showMessage("error", "msg-erro-dados-geral");
                })
                .finally((_) => {
                    this.$store.commit("removeLoader");
                });
        },
        saveMotivoNaoVenda(redirect = this.redirectToList) {
            let motivonaovendatemp = { ...this.mapTosave(this.motivonaovenda) };

            if (this.validation.validate(motivonaovendatemp, this.$refs)) {
                this.isSaving = true;

                motivonaovendatemp.situacao = motivonaovendatemp.situacao.id;

                this.service
                    .save(motivonaovendatemp)
                    .then((body) => {
                        let msg = "msg-motivonaovenda-salva";

                        if (motivonaovendatemp.id) {
                            msg = "msg-motivonaovenda-edita";
                        }

                        this.motivonaovenda = body.content;
                        if (body.content.situacao in [0, 1]) {
                            this.motivonaovenda.situacao =
                                this.situacoes[body.content.situacao];
                        } else {
                            console.warn(
                                `ID de situação inválido ao carregar motivo de não venda: ${body.content.situacao}`
                            );
                            this.motivonaovenda.situacao = this.situacoes[1];
                        }
                        this.$root.showMessage("success", msg);
                        redirect(2);
                    })
                    .catch((e) => {
                        let message = e.body.message;
                        if (message && this.$te(message)) {
                            if (message == "msg-codigo-duplicado-n") {
                                this.$root.showMessage(
                                    "alert", 
                                    this.$t(message, { n: motivonaovendatemp.idmotivonaovendaerp }), 
                                    true, 
                                    false
                                );
                            } else {
                                this.$root.showMessage("alert", message);
                            }

                            return;
                        }

                        this.$root.showMessage(
                            "error",
                            "msg-problema-realizar-acao"
                        );
                    })
                    .finally((_) => {
                        this.isSaving = false;
                    });
            }
        },
        getLabel(option) {
            if (option.label != undefined) {
                return this.$t(option.label);
            } else {
                return this.$t(option);
            }
        },
        validateOculta(oculta, key) {
            if (oculta) {
                if (key == "fotos") {
                    this.motivonaovenda["minimo" + key] = 0;
                } else {
                    this.motivonaovenda["obriga" + key] = false;
                }
            }
        },
        redirectToList(time) {
            setTimeout(() => {
                this.$router.push({ name: "venda-motivo-nao-venda" });
            }, time * 1000 + 50);
        },
        generateId(numberId) {
            return this.$route.name + "-geral-" + numberId;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "./mixins.scss";

.column {
    @include default-size-column;
}

#main {
    padding: 0 20px;
    height: auto;
}
.page {
    position: relative;
    margin-bottom: 40px;

    .novo-motivonaovenda {
        position: relative;
        width: 100%;
        margin-bottom: 20px;
        height: 100%;
        padding-top: 0;
        > h1 {
            padding-top: 20px;
            margin-bottom: 40px;
        }

        .situacao-input {
            padding-top: 0.75rem;
            > .v-select {
                height: 36px;
            }
        }
    }
}

.novo-motivonaovenda .center {
    width: 100%;
    left: 0;
    transform: translateX(0);
    margin: 0;
    box-sizing: border-box;
    position: initial;
    padding-bottom: 20px;
}

.form-buttons {
    right: 0;
}

@media only screen and (min-width: 760px) {
    nav.breadcrumb {
        margin-right: 410px;
    }
}

.novo-motivonaovenda .form {
    // display: block;
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    border-radius: 2px;
    text-align: left;

    .descricao-input {
        width: 100%;
    }

    .location {
        width: 100%;
        height: auto;
        flex: 1 1 auto;
        margin-top: 20px;
        position: relative;
        min-height: 300px;
        height: auto;
        margin-bottom: 20px;

        .getlocation {
            position: absolute;
            margin-left: 0;
            bottom: -60px;
        }
    }
}
</style>